import { useMutation } from "react-query";
import http from "infra/http";

function useDeleteCliente() {
  return useMutation(
    `/v1/cliente/id`,
    (id: string) => http.delete(`/v1/cliente/${id}`),
    { retry: false }
  );
}

export default useDeleteCliente;
